import { c as _c } from "react/compiler-runtime";
/* eslint-disable no-unused-expressions */
import { useKey } from 'react-use';
import { isLeftArrowKey, isRightArrowKey } from '../helpers/keys';
const useKeyboardControlForIndexedItems = t0 => {
  const $ = _c(12);
  const {
    isEnabled: t1,
    numberOfItems: t2,
    selectedIndex,
    setSelectedIndex
  } = t0;
  const isEnabled = t1 === undefined ? false : t1;
  const numberOfItems = t2 === undefined ? 0 : t2;
  let t3;
  if ($[0] !== isEnabled || $[1] !== numberOfItems || $[2] !== selectedIndex || $[3] !== setSelectedIndex) {
    t3 = event => {
      if (isEnabled && !!numberOfItems && !!setSelectedIndex && typeof selectedIndex !== "undefined") {
        event.preventDefault();
        const nextIndex = selectedIndex + 1;
        if (nextIndex >= numberOfItems) {
          setSelectedIndex(0);
        } else {
          setSelectedIndex(nextIndex);
        }
      }
    };
    $[0] = isEnabled;
    $[1] = numberOfItems;
    $[2] = selectedIndex;
    $[3] = setSelectedIndex;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      event: "keydown"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useKey(_temp, t3, t4);
  let t5;
  if ($[6] !== isEnabled || $[7] !== numberOfItems || $[8] !== selectedIndex || $[9] !== setSelectedIndex) {
    t5 = event_0 => {
      if (isEnabled && !!numberOfItems && !!setSelectedIndex && typeof selectedIndex !== "undefined") {
        event_0.preventDefault();
        const previousIndex = selectedIndex - 1;
        if (previousIndex < 0) {
          setSelectedIndex(numberOfItems - 1);
        } else {
          setSelectedIndex(previousIndex);
        }
      }
    };
    $[6] = isEnabled;
    $[7] = numberOfItems;
    $[8] = selectedIndex;
    $[9] = setSelectedIndex;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      event: "keydown"
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useKey(_temp2, t5, t6);
};
export default useKeyboardControlForIndexedItems;
function _temp(key) {
  return isRightArrowKey(key);
}
function _temp2(key_0) {
  return isLeftArrowKey(key_0);
}